import * as tslib_1 from "tslib";
import { Command } from './command';
var Button = /** @class */ (function (_super) {
    tslib_1.__extends(Button, _super);
    function Button(param) {
        return _super.call(this, param) || this;
    }
    Button.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "Button" });
    };
    Button.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Button;
}(Command));
export { Button };
//# sourceMappingURL=button.js.map